let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ef4Ev")).then(() => parcelRequire('ez8W0'));